(ns ui.view.card.counterparty-diligence-screening.model)

(defn entity-risk-screen-url
  [external-screening-id]
  (str "https://batch.riskscreen.com/entity/view/" external-screening-id "?pageindex=0&rowsperpage=100"))

(def selected-legal-entities-path [:selected-legal-entities])

(defn selected-legal-entities-full-path
  [card-state-path]
  (into card-state-path selected-legal-entities-path))

(def selected-legal-entity-key-persons-path [:selected-legal-entity-key-persons])

(defn selected-legal-entity-key-persons-full-path
  [card-state-path]
  (into card-state-path selected-legal-entity-key-persons-path))

(def selected-natural-persons-path [:selected-natural-persons])

(def expanded-table-rows-path [:expanded-table-rows])

(defn expanded-table-rows-full-path
  [card-state-path]
  (into card-state-path expanded-table-rows-path))

(defn selected-natural-persons-full-path
  [card-state-path]
  (into card-state-path selected-natural-persons-path))

(def send-to-screening-modal-state-path [:send-to-screening-modal])

(defn send-to-screening-modal-state-full-path
  [card-state-path]
  (into card-state-path send-to-screening-modal-state-path))

(def sending-to-screening-path [:sending-to-screening?])

(defn sending-to-screening-full-path
  [card-state-path]
  (into card-state-path sending-to-screening-path))
